export enum ResponseStatus {
  OK,
  KO,
  Pending,
}
